import React from 'react';
import { Link } from 'react-router-dom';
import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchGet } from '../../store/fetch';
import { IRouterProps } from '../../utils/IRouterProps';

interface IObjectTypeDefectsProps extends ITranslateProps, IRouterProps {
    location: any;
}

interface IObjectTypeDefect {
    id: string;
    name: string;
    code: string;
}

interface IObjectTypeDefectstState {
    items: IObjectTypeDefect[];
}

class ObjectTypeDefectsEdit extends React.Component<IObjectTypeDefectsProps, IObjectTypeDefectstState> {
    constructor(props: IObjectTypeDefectsProps) {
        super(props);

        this.state = {
            items: [],
        };
    }

    public override async componentDidMount() {
        await this.load();
    }

    public override render() {
        return (
            <div>
                <header id="topbar" className="ph10">
                    <div className="topbar-left">
                        <ol className="breadcrumb">
                            <li className="crumb-active">
                                <span className="fa fa-cogs pr10"></span>
                                <a href="#"> {this.props.t('failureMode.failureMode')} </a>
                            </li>
                            <li className="crumb-trail">
                                <Link
                                    to={`/settings/objecttypes/inspectionstandards/${this.props.location.query.inspectionstandardid}/editobjecttemplate?inspectiontype=nen2767`}
                                >
                                    {this.props.t('common.composition')}
                                </Link>
                            </li>
                            <li className="crumb-trail">
                                <Link to={'/settings/objecttypes/'}>{this.props.t('common.objectTypes')}</Link>
                            </li>
                        </ol>
                    </div>
                </header>
                <section id="content" className="table-layout animated fadeIn">
                    <div className="tray tray-center">
                        <div className="admin-form theme-primary mw1000 center-block">
                            <div className="panel">
                                <div className="panel-body pn">
                                    <div className="table-responsive">
                                        <table className="table table-hover fs13">
                                            <thead>
                                                <tr className="bg-light">
                                                    <th className="">{this.props.t('common.code')}</th>
                                                    <th className="">{this.props.t('common.name')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.items &&
                                                    this.state.items.map((item) => (
                                                        <tr key={item.id}>
                                                            <td className="text-left">{item.code}</td>
                                                            <td className="text-left">{item.name}</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    private async load() {
        const url = `/api/inspectionStandards/${this.props.location.query.inspectionstandardid}/objectTypeUnits/${this.props.match.params.code}/objectTypeDefects`;
        const result = await fetchGet(url);
        this.setState({ items: result.json });
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(ObjectTypeDefectsEdit);
